import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import LazoUserService from "@/services/LazoUserService";

export type LazoApplicationOptions = Record<string, boolean> & {
  hideArchiveConversationModal: boolean;
};

class LazoApplicationOptionsService {
  private lazoUserExternalId: string = "";
  options: LazoApplicationOptions = {} as LazoApplicationOptions;
  constructor() {}
  initialize(lazoUserExternalId: string, options: LazoApplicationOptions) {
    this.lazoUserExternalId = lazoUserExternalId;
    this.options = options;
  }
  save() {
    LazoUserService.saveOptions(this.lazoUserExternalId, this.options)
      .then((r) => {
        r.getContentOrThrowError();
      })
      .catch((e: { message: string }) => NotificationService.error(e.message));
  }
}

const LAZO_APPLICATIONS_OPTIONS_SERVICE = new LazoApplicationOptionsService();
export { LAZO_APPLICATIONS_OPTIONS_SERVICE };
